import { useEffect, useRef } from 'react'

import classNames from 'classnames'

import './ControlledCheckbox.scss'
import { Icon } from '@/Atomic/Atoms/Icon'

interface ControlledCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  inputWrapperClassName?: string
  label?: string
}

const ControlledCheckbox: React.FC<ControlledCheckboxProps> = ({
  inputWrapperClassName,
  className,
  checked,
  disabled,
  onChange,
  label,
  ...props
}) => {
  const checkboxRef = useRef<HTMLInputElement | null>(null)

  useEffect(() => {
    if (!checkboxRef.current) {
      return
    }
    if (checked === true) {
      checkboxRef.current.checked = true
      checkboxRef.current.indeterminate = false
    } else if (checked === false) {
      checkboxRef.current.checked = false
      checkboxRef.current.indeterminate = false
    } else if (checked === undefined) {
      checkboxRef.current.checked = false
      checkboxRef.current.indeterminate = true
    }
  }, [checked])

  const wrapperClass = classNames(
    'controlled-checkbox-wrapper',
    { checked: checked === true },
    { unchecked: checked === false },
    { indeterminate: checked === undefined },
    { 'controlled-checkbox-wrapper--disabled': disabled },
    inputWrapperClassName,
  )

  const box = (
    <div className="controlled-checkbox-box">
      {checked === true && (
        <Icon
          className="controlled-checkbox-icon"
          icon="check"
          color="white"
          size="sm"
        />
      )}
      {checked === undefined && (
        <Icon
          className="controlled-checkbox-icon"
          icon="minus"
          color="white"
          size="sm"
        />
      )}
      <input
        className={classNames('controlled-checkbox-input', className)}
        ref={checkboxRef}
        type="checkbox"
        disabled={disabled}
        onChange={onChange}
        {...props}
      />
    </div>
  )

  if (label) {
    return (
      <label className={wrapperClass}>
        {box}
        <span className="controlled-checkbox-label">{label}</span>
      </label>
    )
  }

  return <div className={wrapperClass}>{box}</div>
}

const stateTransition = (checked: boolean | undefined) => {
  if (checked === true) {
    return false
  } else {
    return true
  }
}

export { ControlledCheckbox, stateTransition }
export type { ControlledCheckboxProps }
